export default __webpack_public_path__ + "static/media/winning-bid.822f4ec9.png";